<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
                <md-icon>receipt_long</md-icon>
            </div>
        </md-card-header>
        <md-card-content>
            <p v-if="!lines || lines.length === 0" class="grayedout-text">No item provided.</p>
            <div v-else>
                <md-table class="context-menu-support custom-paginated-table">
                    <md-table-row>
                        <md-table-head>Description</md-table-head>
                        <md-table-head v-if="!isMobileView">Quantity</md-table-head>
                        <md-table-head v-if="!isMobileView">Unit Cost (Ex-Tax)</md-table-head>
                        <md-table-head>Total Amount (Ex-Tax)</md-table-head>
                        <md-table-head>Ref</md-table-head>
                        <md-table-head v-if="!isMobileView">Status</md-table-head>
                        <md-table-head>Action</md-table-head>
                    </md-table-row>
                    <md-table-row v-for="(line, index) in lines" :key="index">
                        <md-table-cell>{{ line.description }}</md-table-cell>
                        <md-table-cell v-if="!isMobileView">
                            {{ line.quantity }}
                            <span class="quantity-type">{{ line.quantityType }}</span>
                        </md-table-cell>
                        <md-table-cell v-if="!isMobileView">
                            {{ line.unitPriceExTax | currency(line.priceCurrency) }}
                        </md-table-cell>
                        <md-table-cell>
                            {{ (line.unitPriceExTax * line.quantity) | currency(line.priceCurrency) }}
                        </md-table-cell>
                        <md-table-cell>
                            <router-link
                                v-if="line.stopId"
                                :to="{ name: 'Stop Details', params: { stopId: line.stopId } }"
                                target="_blank"
                            >
                                {{ line.stopRef }}
                            </router-link>
                            <router-link
                                v-else-if="line.shipmentId"
                                :to="{ name: 'Shipment Details', params: { shipmentId: line.shipmentId } }"
                                target="_blank"
                            >
                                {{ line.shipmentRef }}
                            </router-link>
                            <router-link
                                v-else-if="line.tripId"
                                :to="{ name: 'Trip Details', params: { tripId: line.tripId } }"
                                target="_blank"
                            >
                                {{ line.tripRef }}
                            </router-link>
                            <router-link
                                v-else-if="line.runId"
                                :to="{ name: 'Run Details', params: { runId: line.runId } }"
                                target="_blank"
                            >
                                {{ line.runRef }}
                            </router-link>
                        </md-table-cell>
                        <md-table-cell v-if="!isMobileView">
                            {{ line.status }}
                        </md-table-cell>
                        <md-table-cell>
                            <create-issue
                                v-if="(line.stopId || line.shipmentId || line.tripId) && line.serviceId === null"
                                v-feature="FEATURE_NAMES.IssueTracking"
                                :related-entity-type="$_issueRelatedEntityType(line)"
                                :related-entity-ref="$_issueRelatedEntityReference(line)"
                            />
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { CreateIssue } from '@/pages/Issues/Components';
import { FEATURE_NAMES } from '@/utils/constants';

export default {
    name: 'InvoiceLines',
    mixins: [GeneralMixin],
    components: {
        CreateIssue
    },
    props: {
        lines: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            FEATURE_NAMES
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isReadOnlyUser: 'user/isReadOnlyUser'
        }),
        isMobileView() {
            return window.innerWidth <= 768 || this.$root.isMobileOnly;
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-btn {
    margin-right: 16px;
}
.action-button {
    display: inline-block;
}
</style>
